export const TIMESHEET = 'timesheet';
export const LOG_OTHER_HOURS = 'log other hours';

export default Object.freeze({
    TIMESHEET,
    LOG_OTHER_HOURS
});